<template>
  <div>
    <div class="main-width menu">
      <img src="../assets/img/titlelogo.png" @click="goHome()" />
      <div class="login-css" @click="goManage()">
        登录
      </div>
      <el-menu
        :default-active="onRoutes"
        background-color="#035AB1"
        text-color="#ffffff"
        mode="horizontal"
        style="height: 45px !important;width: 100%;border:none;"
        active-text-color="#ffffff"
        unique-opened
        router
      >
        <el-menu-item
          v-for="item in items"
          :key="item.index"
          :index="item.index"
          class="menu-item"
        >
          {{ item.title }}
        </el-menu-item>
        <!-- <div class="menu-time">
          {{ date.year }}年{{ date.month }}月
        </div> -->
        <div class="search">
          <el-input
            v-model="test"
            placeholder="请输入关键词进行搜索..."
          ></el-input>
          <div class="search-text">搜索</div>
        </div>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      test: "",
      date: {},
      items: [
        {
          index: "/home",
          title: "首页",
        },
        {
          index: "/culture",
          title: "黄酒文化",
        },
        {
          index: "/news",
          title: "行业资讯",
        },
        {
          index: "/info",
          title: "信息公开",
        },
        {
          index: "/service",
          title: "在线留言",
        },
        {
          index: "/group",
          title: "黄酒协会",
        },
        // {
        //   index: "/home4",
        //   title: "会员登录",
        // },
      ],
      // items: [{
      //     index: "/home",
      //     title: "首页"
      // }, {
      //     index: "/culture",
      //     title: "黄酒文化"
      // }, {
      //     index: "/news",
      //     title: "产业动态"
      // }, {
      //     index: "/notice",
      //     title: "通知公告"
      // }, {
      //     index: "/service",
      //     title: "服务互动"
      // }, {
      //     index: "/product",
      //     title: "产品追溯"
      // }, {
      //     index: "/company",
      //     title: "单位概况"
      // }]
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    },
  },
  methods: {
    goManage: function() {
      window.open("http://101.132.106.62/fxManage/#/login");
    },
    goHome: function() {
      this.$router.push("/home");
    },
    getWeekDay(date) {
      var weekArray = new Array("日", "一", "二", "三", "四", "五", "六");
      var week = weekArray[new Date(date).getDay()]; //注意此处必须是先new一个Date
      return week;
    },
  },
  // created() {
  //   let date = new Date();
  //   let year = date.getFullYear();
  //   let month = date.getMonth() + 1;
  //   let day = date.getDate();
  //   let week = this.getWeekDay(date);
  //   this.$set(this, "date", {
  //     year,
  //     month: month < 10 ? "0" + month : month,
  //     day: day < 10 ? "0" + day : day,
  //     week,
  //   });
  // },
};
</script>
<style scoped lang="scss">
.menu {
  z-index: 1000;
  position: relative;
  color: #ffffff;
  img {
    margin-top: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    width: 300px;
    // height: 70px;
  }
  &-time {
    height: 45px;
    line-height: 45px;
    width: 200px;
    left: 620px;
    position: absolute;
  }
  &-item {
    font-size: 14px;
    width: 110px;
    text-align: center;
    line-height: 45px !important;
  }
}
::v-deep {
  .el-input--small .el-input__inner {
    height: 25px;
    line-height: 25px;
    border-radius: 0px;
  }
  .el-input__inner::placeholder {
    font-size: 12px;
    color: #999999;
  }
}
.search {
  height: 25px;
  display: flex;
  width: 260px;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -12.5px;
  &-text {
    font-size: 12px;
    width: 50px;
    line-height: 25px;
    text-align: center;
    background: linear-gradient(rgb(191, 223, 255) 0%, rgb(243, 249, 255) 99%);
    color: #035ab1;
    cursor: pointer;
  }
}
.login-css{
  position: absolute;
  top: 45px;
  right: 0px;
  width: 50px;
  height: 25px;
  border-radius: 5px;
  background-color: #045AB2;
  color: white;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
}
</style>
